
import axiosInstance from "./axiosInstance";



export const fetchState = async (mobile = 1) => {
  const res = await axiosInstance.get(`/master/state?mobile=${mobile}`);
  const raw = res.data?.data;
  return raw || [];
};

export const fetchDistrict = async (stateCode) => {
  const res = await axiosInstance.get(`/master/district?state_code=${stateCode}`);
  const raw = res.data?.data;
  return raw || [];
};

export const fetchTaluka = async (districtCode) => {
  const res = await axiosInstance.get(`/master/taluka?dist_code=${districtCode}`);
  const raw = res.data?.data;
  return raw || [];
};

export const updateLocation = async (data) => {
  const res = await axiosInstance.post(`/Dash/master_update`,data);
  const raw = res.data?.data;
  return raw || [];
};

export const fetchRegionandTerritory = async (state,category) => {
  const res = await axiosInstance.get(`/Dash/get_region_territory?state=${state}&category=${category}`);
  const raw = res.data?.data;
  return raw || [];
};

export const createTerritory = async (data) => {
  const res = await axiosInstance.post(`/Dash/add_territory`,data);
  const raw = res.data;
  return raw || [];
};

export const createRegion = async (data) => {
  const res = await axiosInstance.post(`/Dash/add_region`,data);
  const raw = res.data;
  return raw || [];
};
